import { AutogenModelNmfcCode, AutogenRowNmfcCode } from "./autogen/AutogenModelNmfcCode";

export class ModelNmfcCode extends AutogenModelNmfcCode<RowNmfcCode> {
    constructor() {
        super(RowNmfcCode);
    }
}

export class RowNmfcCode extends AutogenRowNmfcCode {
}